// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-10-12T21:55:43Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Controller pro konfiguraci a generování CAPTCHA challenges. Podporuje Google reCAPTCHA, FriendlyCaptcha a Altcha. Generated from cz.marbes.eosp.controller.CaptchaController.
 */
export default class CaptchaApi {
    /**
     * Generuje novou Altcha challenge pro proof-of-work ověření. @return Altcha challenge
     *
     * @return cz.marbes.eosp.controller.vo.AltchaChallengeVO
     */
    static getAltchaChallenge() {
        const uri = serverContextPath + `/api/captcha/altcha-challenge`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí konfiguraci aktivního poskytovatele CAPTCHA, nebo {@code null} pokud CAPTCHA není vyžadována. @return konfigurace CAPTCHA nebo {@code null}
     *
     * @return cz.marbes.eosp.controller.vo.CaptchaConfigVO
     */
    static getCaptchaConfig() {
        const uri = serverContextPath + `/api/captcha/config`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
